import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    variants: Array,
    currentCondition: String,
    currentColor: String
  }

  static targets = ['conditionPill', 'colorSwatch']

  connect () {
    this.selectedCondition = this.currentConditionValue
    this.selectedColor = this.currentColorValue
    this.refresh()
  }

  selectCondition (e) {
    const condition = e.currentTarget.dataset.condition

    if (this.selectedCondition === condition) {
      this.selectedCondition = null
      this.refresh()
      return
    }

    this.selectedCondition = condition

    if (this.selectedColor) {
      const match = this.findVariant(this.selectedCondition, this.selectedColor)
      if (match) { Turbo.visit(match.url); return }

      const fallback = this.variantsValue.find(v => v.condition === this.selectedCondition)
      if (fallback) Turbo.visit(fallback.url)
    } else {
      this.refresh()
    }
  }

  selectColor (e) {
    const color = e.currentTarget.dataset.color

    if (this.selectedColor === color) {
      this.selectedColor = null
      this.refresh()
      return
    }

    this.selectedColor = color

    if (this.selectedCondition) {
      const match = this.findVariant(this.selectedCondition, this.selectedColor)
      if (match) { Turbo.visit(match.url); return }

      const fallback = this.variantsValue.find(v => v.color === this.selectedColor)
      if (fallback) Turbo.visit(fallback.url)
    } else {
      this.refresh()
    }
  }

  refresh () {
    const availableConditions = this.selectedColor
      ? new Set(this.variantsValue.filter(v => v.color === this.selectedColor).map(v => v.condition))
      : new Set(this.variantsValue.map(v => v.condition))

    this.conditionPillTargets.forEach(pill => {
      const selected = pill.dataset.condition === this.selectedCondition
      const available = availableConditions.has(pill.dataset.condition)
      pill.classList.toggle('selected', selected)
      pill.classList.toggle('disabled', !available && !selected)
      pill.disabled = !available && !selected
    })

    this.colorSwatchTargets.forEach(swatch => {
      swatch.classList.toggle('selected', swatch.dataset.color === this.selectedColor)
    })
  }

  findVariant (condition, color) {
    return this.variantsValue.find(v => v.condition === condition && v.color === color)
  }
}
